import API from 'API';

const API_LIST = {
    GET_PLANS: '/subscriptions/plans?platform=web',
};

export function getSubscriptionPlans() {
    return API.get(API_LIST.GET_PLANS);
}
